@if (label) {
  <label>{{ label | transloco }}</label>
}

<nz-radio-group
  [(ngModel)]="internalValue"
  [class.button-group]="asButtonGroup"
  [nzDisabled]="disabled"
  (ngModelChange)="onModelChange($event)">
  @for (option of options; track option.value) {
    <label
      nz-radio
      [nzDisabled]="option?.disabled"
      [nzValue]="option.value">
      <span class="option-label">
        @if (option.icon) {
          <ui-icon [key]="option.icon"></ui-icon>
        }
        {{ option.label | transloco }}
      </span>
    </label>
  }
</nz-radio-group>
